import { LucideIcon } from "lucide-react";
import { Card } from "@/components/ui/card";
import { cn } from "@/lib/utils";

interface MetricCardProps {
  title: string;
  value: string | number;
  change?: string;
  trend?: "up" | "down" | "neutral";
  icon: LucideIcon;
  iconColor?: string;
}

export const MetricCard = ({
  title,
  value,
  change,
  trend = "neutral",
  icon: Icon,
  iconColor = "text-primary",
}: MetricCardProps) => {
  return (
    <Card className="p-3 sm:p-4 md:p-6 hover:shadow-lg transition-shadow bg-gradient-to-br from-card to-card/50">
      <div className="flex items-start justify-between gap-2">
        <div className="flex-1 min-w-0">
          <p className="text-xs sm:text-sm font-medium text-muted-foreground truncate">{title}</p>
          <p className="text-xl sm:text-2xl md:text-3xl font-bold mt-1 sm:mt-2 text-foreground">{value}</p>
          {change && (
            <p
              className={cn(
                "text-xs sm:text-sm mt-1 sm:mt-2 font-medium truncate",
                trend === "up" && "text-accent",
                trend === "down" && "text-destructive",
                trend === "neutral" && "text-muted-foreground"
              )}
            >
              {change}
            </p>
          )}
        </div>
        <div className={cn("p-2 sm:p-3 rounded-lg sm:rounded-xl bg-primary/10 flex-shrink-0", iconColor)}>
          <Icon className="w-4 h-4 sm:w-5 sm:h-5 md:w-6 md:h-6" />
        </div>
      </div>
    </Card>
  );
};
